import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { ReportService, Combo2Service,ExcelService } from "../../../../services/index";
@Component({
  selector: "bulkPendingReport",
  templateUrl: "bulkPendingReport.html",
})
export class bulkPendingReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  order_no: any = "";
  loading = false;
  designType = [];
  data: any = {};
  detail: any = {};
  row = [];
  backbutExists: boolean = false;
  filter: any = {
    finyear: "",
    fin_id: "",
    season_id: "",
    season: "",
    from_date: "",
    to_date: "",
    groupby: "party",
    party_id: "",
    // po_id: "",
    party_code: "",
    po_no: "",
    book_no: "",
    po_date : "",
    po_from_date: "",
    po_to_date: ""
  };
  gridOptions: any;
  menu: any;
  exceldata: any;
  columnDefs: any[];
  isLoadMask: Promise<any>;
  loadingIndicator: boolean = true;
  columns = [];
  rowData: any[] = [];
  orderList: any = [];
  finyearList = [];
  toggleCol = [];
  @ViewChild("tabContent") tabContent;
  @ViewChild("entryContainer") entryContainer;
  @ViewChild("listContainer") listContainer;
  seasonList: any = [];
  constructor(
    private service: ReportService,
    private dp: DatePipe,
    private combo2Service: Combo2Service,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {
    const date = new Date();
    let oneMnthDate =
      date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
    let oneMonthBeforeDate = new Date(oneMnthDate);
    this.filter.from_date = oneMonthBeforeDate;
    this.filter.to_date = date;
   this.filter.po_from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.po_to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  }
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_id",
    orderDir: "ASC",
  };
  printConfig: any = {
    title: "BULK PENDING",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.getColumns();
    //   this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.pageCallback({ offset: 0 });
  }
  applyFilter() {
    this.sampleSwatchPending();
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  onCellClick(event) {
    if (this.filter.groupby == "party") {
      this.filter.party_id = event.row.party_id;
      this.filter.party_code = event.row.party_code;
      this.filter.groupby = "po";
    }
     else if (this.filter.groupby == "po") {
      this.filter.party_id = event.row.party_id;
      this.filter.party_code = event.row.party_code;
      this.filter.po_date = event.row.po_date;
      this.filter.po_no = event.row.po_no;
      this.filter.book_no = event.row.book_no;
      this.filter.groupby = "design";
    }
    else if (this.filter.groupby == "design") {
      this.filter.party_id = event.row.party_id;
      this.filter.po_date = event.row.po_date;
      this.filter.groupby = "entry_wise";
    }
    

    this.sampleSwatchPending();
  }
  // finyearCombo() {
  //   let that = this;
  //   this.combo2Service.finyearCombo().then((res: any) => {
  //     that.finyearList = res.data;
  //     let now = new Date();
  //     let checkDate = now.getFullYear() + "-" + (now.getMonth() - 1 ) + "-" + now.getDate();
  //     that.finyearList.forEach((el) => {
  //       if (checkDate >= el.start_date && checkDate <= el.end_date) {
  //         that.filter.finyear = el.finyear;
  //         that.filter.fin_id = el.fin_id;
  //         that.sampleSwatchPending();
  //         // that.getSeasonList();
  //       }
  //     });
  //   });
  // }
  // getSeasonList() {
  //   let params = {
  //     fin_id: this.filter.fin_id,
  //   };
  //   this.isLoadMask = this.service
  //     .getPurchaseSeason(params)
  //     .then((res: any) => {
  //       this.seasonList = res;
  //       this.filter.season_id = res[res["length"] - 1].season_id;
  //       this.filter.season = res[res["length"] - 1].season;
  //       this.allseason();
  //       this.sampleSwatchPending();
  //     })
  //     .catch((err) => {
  //       this.loading = false;
  //     });
  // }
  // allseason() {
  //   let fin_id = parseInt(this.filter.fin_id);

  //   this.seasonList.forEach(() => {
  //     let seasonAll = {
  //       season: "ALL",
  //       season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
  //       fin_id: fin_id
  //     };
  //     if (fin_id > 0) {
  //       this.seasonList.push(seasonAll);
  //     }
  //     fin_id = fin_id - 1;
  //   });
  // }

  sampleSwatchPending() {
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.filter.po_from_date =
      this.datePipe.transform(this.filter.po_from_date, "yyyy-MM-dd");

    this.filter.po_to_date = this.datePipe.transform(
      this.filter.po_to_date,
      "yyyy-MM-dd"
    );
    this.loadingIndicator = true;
    let params = {
      filter: JSON.stringify(this.filter),
      report_type: "bulk",
    };
    this.isLoadMask = this.service
      .bulkPendingReport(params)
      .then((res: any) => {
        if (res.success) {
          this.loadingIndicator = false;
          this.page.count = res.totCnt;
          this.orderList = res.data;
          this.gridOptions = {
            cols: res.cols,
            columns: res.columns,
            data: res.data,
            loading: false,
          };
          this.filter.order_no = "";
          this.exceldata = this.getData(res.columns, res.data);
        }
        this.backbutton();
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
      });
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onbackbutton() {
    if (this.filter.groupby == "po") {
      this.filter.groupby = "party";
      this.filter.party_id = "";
    } 
    else if (this.filter.groupby == "design") {
      this.filter.groupby = "po";
      this.filter.book_no = "";
      this.filter.po_date = "";
    }
    else if (this.filter.groupby == "entry_wise") {
      this.filter.groupby = "design";
    }

    this.sampleSwatchPending();
  }
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.sampleSwatchPending();
  }

  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/POStatusReports/bulkPendingReport/bulkPendingReport.ts